export enum StudyPlanActionTypes {
  SET_CURRENT_PLAN = '@studyPlan/SET_CURRENT_PLAN',
  SET_PLANS_LIST = '@studyPlan/SET_PLANS_LIST',
  ADD_PLAN = '@studyPlan/ADD_PLAN',
  UPDATE_PLAN = '@studyPlan/UPDATE_PLAN',
  SET_LOADING = '@studyPlan/SET_LOADING',
  SET_ERROR = '@studyPlan/SET_ERROR',
  CLEAR_ERROR = '@studyPlan/CLEAR_ERROR',
  REMOVE_PLAN = '@studyPlan/REMOVE_PLAN',
  CLEAR_STUDY_PLAN = '@studyPlan/CLEAR_STUDY_PLAN',
}

export interface IStudyPlanModule {
  _id: string
  subject: string
  relevance: number
  knowledge: number
  weight: number
  percentage: number
  hours: number
  sessions: number
}

export interface IStudyPlan {
  _id: string
  name: string
  active: boolean
  type: string
  progress: {
    percentage: number
    hours: number
    completed: number
  }
  student?: {
    _id: string
    name: string
    email: string
  }
  publicTender?: {
    _id: string
    icon: string
    name: string
    role: string
    career: string
  }
  course?: {
    _id: string
    name: string
  }
  config: {
    cycle: {
      weekdays: string[]
      hours: number
      duration: {
        min: number
        max: number
      }
      algorithm: string
    }
  }
  modules: IStudyPlanModule[]
  createdAt: string
  updatedAt: string
  __v?: number
}

export interface IStudyPlanState {
  currentPlanId: string | null
  plans: IStudyPlan[]
  loading: boolean
  error: string | null
}

export interface ISetCurrentPlan {
  type: typeof StudyPlanActionTypes.SET_CURRENT_PLAN
  payload: string | null
}

export interface ISetPlansList {
  type: typeof StudyPlanActionTypes.SET_PLANS_LIST
  payload: IStudyPlan[]
}

export interface ISetLoading {
  type: typeof StudyPlanActionTypes.SET_LOADING
  payload: boolean
}

export interface ISetError {
  type: typeof StudyPlanActionTypes.SET_ERROR
  payload: string
}

export interface IClearError {
  type: typeof StudyPlanActionTypes.CLEAR_ERROR
}

export interface IRemovePlan {
  type: typeof StudyPlanActionTypes.REMOVE_PLAN
  payload: string
}

export interface IAddPlan {
  type: typeof StudyPlanActionTypes.ADD_PLAN
  payload: IStudyPlan
}

export interface IUpdatePlan {
  type: typeof StudyPlanActionTypes.UPDATE_PLAN
  payload: IStudyPlan
}

export interface IClearStudyPlan {
  type: typeof StudyPlanActionTypes.CLEAR_STUDY_PLAN
}

export type StudyPlanActions =
  | ISetCurrentPlan
  | ISetPlansList
  | IAddPlan
  | IUpdatePlan
  | ISetLoading
  | ISetError
  | IClearError
  | IRemovePlan
  | IClearStudyPlan
